import React, { PropTypes } from 'react';
import Select from 'react-select';
import ReactTooltip from 'react-tooltip';
import { selectify } from "../../businessLogic/util";
import { difference } from 'lodash';
import Layers from './Layers';

export default class FullControl extends React.Component {
	// filterHelper verifies setor e localidade de verdade
	filterHelper = (e) => {

		var selectedProject;
		if (this.props.projects.isMariana === true && this.props.projects.isBrumadinho === true ) {
			return true;
		} else {

			if ( this.props.projects.isMariana === true) {
				selectedProject = 1;
				// return true;
			} else if ( this.props.projects.isBrumadinho === true ) {
				selectedProject = 2;
				// return true;
			}
			// return false;
		}
		if ( e.projeto === selectedProject ) {
			return true;
		} else {
			return false;
		}
	}

	renderFilters () {
		if (this.props.isGisOnly) return;

		const { onAddShape, onRemoveShape, shapes, setSectors, setLocalities, filter } = this.props;
		return (
			<div>
				<div className="form-group">
					<label>Setor</label>
					<Select
						name="sectors-select"
						multi
						value={filter.sectors}
						options={selectify(shapes.sectors.filter((e) => {
							return this.filterHelper(e);
						}))}
						noResultsText="Nenhum resultado encontrado"
						placeholder="Selecione..."
						onChange={(value) => {
							setSectors(value);
							if ( value.length < filter.sectors.length ) onRemoveShape(difference(filter.sectors, value));
							else onAddShape(difference(value, filter.sectors));
						}}
					/>
				</div>
				<div className="form-group">
					<label>Localidade</label>
					<Select
						name="localities-select"
						multi
						value={filter.localities}
						options={selectify(shapes.localities.filter((e) => {
							return this.filterHelper(e);
						}))}
						noResultsText="Nenhum resultado encontrado"
						placeholder="Selecione..."
						onChange={(value) => {
							setLocalities(value);
							if ( value.length < filter.localities.length ) onRemoveShape(difference(filter.localities, value));
							else onAddShape(difference(value, filter.localities));
						}}
					/>
				</div>
				<div className="form-group">
					<label>Palavras-Chave</label>
					<Select
						name="keywords-select"
						options={selectify(this.props.keywords)}
						value={this.props.filter.keywords}
						placeholder="Selecione..."
						multi
						onChange={(value) => this.props.setKeywords(value)}
					/>
				</div>
				<hr />
			</div>
		);
	}

	render () {

		return (
			<div className="map-control-box cs-card">
				<div>
					<i
						className="fa fa-caret-up fa-2x pointer"
						style={{margin: "auto"}}
						data-tip="Ocultar Filtro"
						onClick={() => {
							ReactTooltip.hide();
							this.props.onHide();
						}}
					/>
					<hr style={{marginTop: "5px", marginBottom: "5px"}} />
					{this.renderFilters()}
				</div>
				<Layers
					layers={this.props.layers}
					addLayer={this.props.addLayer}
					removeLayer={this.props.removeLayer}
					moveLayer={this.props.moveLayer}
					resetLayers={this.props.resetLayers}
					zoomToLayer={this.props.zoomToLayer}
					getMapLayerCapabilities={this.props.getMapLayerCapabilities}
					setShowLegend={this.props.setShowLegend}
					showLegend={this.props.showLegend}
					projects={this.props.projects}
					getMapLayers={this.props.getMapLayers}
					changeOneMapLayer={this.props.changeOneMapLayer}
					isFetchingMapLayers={this.props.isFetchingMapLayers}
					maplayers={this.props.maplayers}
					isGisOnly={this.props.isGisOnly}
					isGisAdmin={this.props.isGisAdmin}
				/>
			</div>
		);
	}
}

FullControl.propTypes = {
	onAddShape: PropTypes.func.isRequired,
	onRemoveShape: PropTypes.func.isRequired,
	shapes: PropTypes.object.isRequired,
	setSectors: PropTypes.func.isRequired,
	setLocalities: PropTypes.func.isRequired,
	setSamplingPoints: PropTypes.func.isRequired,
	setKeywords: PropTypes.func.isRequired,
	keywords: PropTypes.array.isRequired,
	filter: PropTypes.object.isRequired,
	layers: PropTypes.array.isRequired,
	getMapLayers: PropTypes.func.isRequired,
	isFetchingMapLayers: PropTypes.bool.isRequired,
	maplayers: PropTypes.array.isRequired,
	changeOneMapLayer: PropTypes.func.isRequired,
	addLayer: PropTypes.func.isRequired,
	removeLayer: PropTypes.func.isRequired,
	moveLayer: PropTypes.func.isRequired,
	zoomToLayer: PropTypes.func.isRequired,
	getMapLayerCapabilities: PropTypes.func.isRequired,
	resetLayers: PropTypes.func.isRequired,
	setShowLegend: PropTypes.func.isRequired,
	showLegend: PropTypes.bool.isRequired,
	onHide: PropTypes.func.isRequired,
	projects: PropTypes.object.isRequired,
	isGisOnly: PropTypes.bool.isRequired,
	isGisAdmin: PropTypes.bool.isRequired
};


// WEBPACK FOOTER //
// ./src/components/Explorer/FullControl.js